import axios, { AxiosRequestConfig } from "axios";
import config from "./index"
import { refreshAccessToken } from "./tokenRefresh";
import { notAuthorizedCodes } from "./notAuthorizedCodes";
const baseURL = config.api.baseUrl;

// NOTE: do not hard-set 'Content-Type': 'multipart/form-data' here. Axios
// auto-generates the multipart Content-Type WITH the required boundary when the
// request body is a FormData; a hard-coded value omits the boundary, so the
// server can't parse the parts (Multer reports "Unexpected field").
const AxiosInstanceFormData = axios.create(
    {
        baseURL: baseURL,
    }
)

AxiosInstanceFormData.interceptors.request.use(
    function (request: AxiosRequestConfig<any> | any) {
        request.headers["Authorization"] = `Bearer ${getLocalAccessToken()}`;
        return request;
    },
    function (error: any) {
        return Promise.reject(error);
    }
);

// Add a response interceptor
AxiosInstanceFormData.interceptors.response.use(
    async function (response: any) {
        return response;
    },
    async function (error: any) {
        const config: AxiosRequestConfig<any> | any = error.config;

        if (
            error.response?.status === 401 &&
            config &&
            !config._retry &&
            error.response.data &&
            notAuthorizedCodes.includes(error.response.data.message)
        ) {
            config._retry = true;
            try {
                const failedToken = String(config.headers?.["Authorization"] ?? "").replace(/^Bearer /, "");
                const newAccess = await refreshAccessToken(failedToken);
                config.headers["Authorization"] = `Bearer ${newAccess}`;
                return AxiosInstanceFormData(config);
            } catch (err) {
                return Promise.reject(error);
            }
        }
        return Promise.reject(error);
    }
);

const getLocalAccessToken = () => {
    return localStorage.getItem("accessToken")
};

export default AxiosInstanceFormData;